import moment from "moment";
import { Button, Card, Form, Modal, ProgressBar, Alert } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import displayGlobalMessage, { toastConfig } from "Utils/DisplayGlobalMessage";
import planLimitMessage from "Utils/planLimitMessage";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import * as constants from "Constants";
import httpService from "services/httpService";
import log from "loglevel";
import { uploadArchiveInChunks } from "Utils/chunkedArchiveUpload";

const StudentFiles = ({
    otherActivityData,
    showStudentFilesModal,
    handleOpenStudentFilesModal,
    handleCloseStudentFilesModal,
    studentFiles,
    setStudentFiles,
    isDisabled,
    student_email,
    student_name
}) => {
    // Upload progress state
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadStatus, setUploadStatus] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [currentUploadingFile, setCurrentUploadingFile] = useState(null);

    const removeAFileFromStudentFiles = (fileObj) => {

        const deleteUploadStudentsFile = async (fileObj) => {
            let _url = constants.base_url + "/otherlabs/activity/";
            log.log({ fileObj });
            let deleteFileUrl = _url + otherActivityData?.id + "/other_submission_files/?required_file_id=" + (fileObj?.required_file_id || fileObj.id);
            let toastId = "";
            try {
                toastId = toast.loading(
                    `Deleting ${(fileObj.name || fileObj?.required_file_name)}`,
                    {
                        position: "top-right",
                        autoClose: false,
                        closeOnClick: false,
                        draggable: false,
                        hideProgressBar: true,
                    }
                );
                const response = await httpService.delete(deleteFileUrl);
                log.log(response.data);
                if (response.status >= 200 && response.status <= 300) {
                    toast.update(toastId, {
                        render: `Deleted ${(fileObj.name || fileObj?.required_file_name)}`,
                        type: "success",
                        position: "top-right",
                        autoClose: 5000,
                        closeOnClick: true,
                        draggable: true,
                        hideProgressBar: false,
                        isLoading: false
                    });
                    setStudentFiles(files => {
                        let _files = files.filter(f => {
                            let filename = (fileObj.name || fileObj.required_file_name);
                            let alreadyPresentFileName = (f.name || f.required_file_name);
                            log.log({ filename, alreadyPresentFileName })
                            return filename !== alreadyPresentFileName;
                        });
                        let _files_ = JSON.parse(JSON.stringify(_files));
                        return _files_;
                    });
                }
            } catch (err) {
                log.error(err);
                toast.update(toastId, {
                    render: `Couldn't delete ${(fileObj.name || fileObj?.required_file_name)}.
                Request Failed ${err?.response?.status ? `with status code: ${err?.response?.status}` : ''}`,
                    type: "error",
                    position: "top-right",
                    autoClose: 5000,
                    closeOnClick: true,
                    draggable: true,
                    hideProgressBar: false,
                    isLoading: false
                })
                return;
            }
        }

        deleteUploadStudentsFile(fileObj);
    }

    const addStudentFiles = (files) => {
        // log.log(files, files instanceof FileList, typeof files);

        if (files instanceof FileList) {
            let fileObjects = [];
            let totalFilesRequired = otherActivityData?.required_files_num;

            let filesGiven = files.length;
            let filesPresent = studentFiles?.length;

            let total_files = filesGiven + filesPresent;

            if (total_files > totalFilesRequired) {
                displayGlobalMessage(`Total files cannot be more than ${otherActivityData?.required_files_num}.`, "error");
                return;
            }

            for (let i = 0; i < filesGiven; i++) {
                let file = files[i];
                log.log(`Processing file ${i + 1}/${filesGiven}: ${file.name}`);
                let alreadyExistingFileIndex = studentFiles?.findIndex(f => f.name === file.name);
                if (alreadyExistingFileIndex !== -1) {
                    log.error(`File ${file.name} already exists at index ${alreadyExistingFileIndex}`);
                    displayGlobalMessage(`${file.name} is already uploaded.`, 'error');
                    return;
                }
                let fileObj = {
                    fileObj: file,
                    name: file.name,
                    timestamp: new Date(),
                    isUploaded: false,
                }
                fileObjects.push(fileObj);
                log.log(`Added ${file.name} to fileObjects`);
            }
            log.log(`Total fileObjects created: ${fileObjects.length}`);

            let requiredFileNames = otherActivityData?.required_files_name;
            let filesToAppend = [];

            if (requiredFileNames === "any") {
                // no checking required
                for (let file of fileObjects) {
                    const fileSizeInMB = file.fileObj.size / (1024 * 1024);
                    if (fileSizeInMB > 10) {
                        displayGlobalMessage(`File size cannot be more than 10MB`, "error");
                        return;
                    }
                    filesToAppend.push(file);
                }
            } else {
                // Split by space and trim commas from each filename
                requiredFileNames = requiredFileNames?.split?.(" ").map(name => name.trim().replace(/,+$/, ''));
                log.log(`Required file names:`, requiredFileNames);

                if (requiredFileNames.length === totalFilesRequired) {
                    let unAddedFiles = []
                    for (let fileName of requiredFileNames) {
                        log.log(`Checking required file: ${fileName}`);
                        let split_file_name = fileName?.split?.(".");
                        let name = split_file_name[0];
                        let extension = split_file_name[1];

                        const regex = new RegExp(extension.replace('.', '\\.') + '$');
                        let requiredFileInFileObjects = "";
                        let requiredFileInStudentFiles = "";

                        if (name === "*") {
                            requiredFileInFileObjects = fileObjects.find(f => regex.test(f.name));
                            requiredFileInStudentFiles = studentFiles.find(f => regex.test(f.name));
                            log.log(`Wildcard match for *.${extension}: found=${!!requiredFileInFileObjects}, alreadyExists=${!!requiredFileInStudentFiles}`);
                        } else {
                            requiredFileInFileObjects = fileObjects.find(f => f.name === fileName);
                            requiredFileInStudentFiles = studentFiles.find(f => f.name === fileName);
                            log.log(`Exact match for ${fileName}: found=${!!requiredFileInFileObjects}, alreadyExists=${!!requiredFileInStudentFiles}`);
                        }

                        if (requiredFileInFileObjects && !requiredFileInStudentFiles) {
                            const fileSizeInMB = requiredFileInFileObjects.fileObj.size / (1024 * 1024);
                            log.log({ fileName, fileSizeInMB, size: requiredFileInFileObjects.fileObj.size });
                            if (fileSizeInMB > 10) {
                                displayGlobalMessage(`File size cannot be more than 10MB`, "error");
                                return;
                            }
                            filesToAppend.push(requiredFileInFileObjects);
                            log.log(`Added ${fileName} to filesToAppend`);
                            displayGlobalMessage(`${fileName} added.`, "info");
                        } else {
                            if (requiredFileInStudentFiles) {
                                log.log(`${fileName} already exists in studentFiles`);
                            } else {
                                log.log(`${fileName} not found in selected files`);
                                unAddedFiles.push(fileName);
                            }
                        }
                    }
                    if (unAddedFiles.length > 0) {
                        let message = <span>Remaining files with the names: {unAddedFiles.map(f => <pre style={{ display: "inline" }}>{f + " "}</pre>)}</span>
                        displayGlobalMessage(message, "info");
                    }
                } else {
                    // this should not happen
                    displayGlobalMessage("Filenames provided are incorrect. The count does not match with the count required. Please contact your instructor to remove unnecessary blank spaces between the files names.", "error");
                    return;
                }
            }

            log.log(`Total files to append: ${filesToAppend.length}`, filesToAppend.map(f => f.name));
            setStudentFiles((files) => {
                let newFiles = (files || []).concat(filesToAppend);
                log.log(`Setting studentFiles with ${newFiles.length} total files:`, newFiles.map(f => f.name));
                return newFiles;
            });

        } else {

        }
    }

    useEffect(() => {
        log.log({ studentFiles });

        const uploadStudentsFile = async (fileObj) => {

            if (otherActivityData?.required_files_num > 0 && studentFiles.length > 0) {
                let filename = fileObj.name;
                let isUploaded = studentFiles.filter(r => r.name === filename).filter(r => r.isUploaded);
                if (isUploaded.length > 0 || !(fileObj.fileObj instanceof File)) {
                    log.log("Already Uploaded")
                    return;
                }

                let currentProgress = 0;

                try {
                    // Set upload state for modal
                    setIsUploading(true);
                    setCurrentUploadingFile(fileObj.name);
                    setUploadProgress(0);
                    setUploadStatus('Preparing upload...');

                    // Progress callback to update modal only
                    const onProgress = (message, progress) => {
                        if (progress !== currentProgress) {
                            currentProgress = progress;

                            // Update modal progress
                            setUploadProgress(progress);
                            setUploadStatus(message);
                        }
                    };

                    // Use chunked upload utility
                    const result = await uploadArchiveInChunks(
                        otherActivityData?.id,
                        fileObj.fileObj,
                        student_email,
                        student_name,
                        onProgress
                    );

                    log.log(result);

                    // Reset upload state for modal on success
                    setIsUploading(false);
                    setUploadProgress(100);
                    setUploadStatus('Upload completed!');

                    setStudentFiles(files => {
                        let index = files.findIndex(f => f.name === (fileObj.name || fileObj?.required_file_name));
                        if (index !== -1) {
                            files[index].isUploaded = true;
                            // Use recordId for deletion, fallback to fileId for backward compatibility
                            files[index]['required_file_id'] = result.recordId || result.fileId;
                            files[index]['id'] = result.recordId || result.fileId;
                            // Note: required_file URL will be set by backend
                        }
                        log.log({ files });
                        let _files = JSON.parse(JSON.stringify(files));

                        // Check if all required files are now uploaded
                        const uploadedCount = _files.filter(f => f.isUploaded || f.id).length;
                        log.log(`Files uploaded: ${uploadedCount}/${otherActivityData?.required_files_num}`);
                        if (uploadedCount === otherActivityData?.required_files_num) {
                            log.log('All files uploaded, closing modal in 2 seconds');
                            setTimeout(() => {
                                handleCloseStudentFilesModal();
                            }, 2000);
                        }

                        return _files;
                    });

                    // Clear progress after a delay
                    setTimeout(() => {
                        setUploadProgress(0);
                        setUploadStatus('');
                        setCurrentUploadingFile(null);
                    }, 2000);

                } catch (err) {
                    log.error(err);

                    // Reset upload state for modal on error
                    setIsUploading(false);
                    setUploadProgress(0);
                    const limitMessage = planLimitMessage(err);
                    setUploadStatus(`Upload failed: ${limitMessage || err.message || 'Request Failed'}`);
                    setCurrentUploadingFile(null);

                    displayGlobalMessage(`Couldn't upload ${(fileObj.name || fileObj?.required_file_name)}. ${limitMessage || 'Request Failed'}`, 'error');
                    return;
                }
            }
        }

        const assesAndUploadStudentFiles = async (notUploadedFiles) => {
            log.log(`Starting upload for ${notUploadedFiles.length} files`);

            for (const unUploadedFile of notUploadedFiles) {
                await uploadStudentsFile(unUploadedFile);
            }

            log.log('All uploads processed');
            // Note: Modal closing is handled in uploadStudentsFile after each upload
        }

        let notUploadedFiles = studentFiles?.filter?.(f => !f.isUploaded);
        log.log({ notUploadedFiles });

        if (notUploadedFiles?.length > 0) {
            assesAndUploadStudentFiles(notUploadedFiles);
        }

    }, [studentFiles]);

    return (<>

        <Card className="text-start" style={{ marginLeft: "10px", marginRight: "10px", marginTop: "20px", padding: "10px", border: "1px solid #ddd" }}>
            <Card.Body>
                <p className="d-flex align-items-center gap-3">
                    <span>
                        <b>No. of files:</b> {otherActivityData?.required_files_num}
                    </span>
                    <span>
                        <b>Required files:</b> {otherActivityData?.required_files_name}
                    </span>
                </p>
                {!isDisabled ?
                    <Button disabled={otherActivityData?.required_files_num === studentFiles.length} onClick={handleOpenStudentFilesModal}>
                        Add Files
                    </Button>
                    : <></>
                }
                {
                    studentFiles?.filter(f => (f.isUploaded || f.id))?.length > 0 ? <>
                        <Card className="background-white" style={{ marginTop: 10, padding: "10px", border: "1px solid #ddd" }}>
                            <Card.Title>Submitted Files:</Card.Title>
                            <Card.Body>
                                <table border={1}>
                                    <tbody>
                                        <tr>
                                            <td><b>Filename</b></td>
                                            <td><b>Timestamp</b></td>
                                            <td><b>View</b></td>
                                            {!isDisabled && <td><b>Delete</b></td>}
                                        </tr>
                                        {
                                            studentFiles?.filter(f => (f.isUploaded || f.id))?.map?.((file, index) => {
                                                return <tr key={index}>
                                                    <td>{(file?.name || file?.required_file_name)}</td>
                                                    <td>{moment(file?.timestamp).format('ddd MMM DD YYYY HH:mm:ss')}</td>
                                                    <td>
                                                        <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            onClick={() => {
                                                                const token = localStorage.token && localStorage.token.split("Token ")[1];
                                                                const fileUrl = `${constants.base_url}/otherlabs/required_file/${file.id}/view/?token=${token}`;
                                                                window.open(fileUrl, '_blank');
                                                            }}
                                                        >
                                                            <FaEye style={{ marginRight: '5px' }} />
                                                            View
                                                        </Button>
                                                    </td>
                                                    {!isDisabled && (
                                                        <td>
                                                            <Button variant="danger" size="sm" onClick={() => removeAFileFromStudentFiles(file)}>
                                                                Delete File
                                                            </Button>
                                                        </td>
                                                    )}
                                                </tr>
                                            })
                                        }
                                    </tbody>
                                </table>
                            </Card.Body>
                        </Card>
                    </> : <>
                        {
                            isDisabled && <Card className="background-white" style={{ marginTop: 10, padding: "10px", border: "1px solid #ddd" }}>
                                No files Submitted
                            </Card>
                        }
                    </>
                }
            </Card.Body>
        </Card>

        <Modal
            show={showStudentFilesModal}
            onHide={handleCloseStudentFilesModal}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton={!isUploading}>
                <Modal.Title>Additional Files</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Please upload files required for lab submission.</p>
                <Form.Group className="py-1">
                    <Form.Control
                        size="sm"
                        multiple
                        type="file"
                        name="additional_files"
                        onChange={(e) => addStudentFiles(e.target.files)}
                        disabled={isUploading}
                    />
                </Form.Group>

                {/* Upload Progress Section */}
                {(isUploading || uploadStatus) && (
                    <Alert variant={uploadStatus === 'Upload failed' ? 'danger' : uploadStatus === 'Upload completed!' ? 'success' : 'info'} className="mt-3">
                        {currentUploadingFile && (
                            <div className="mb-2">
                                <strong>File:</strong> {currentUploadingFile}
                            </div>
                        )}
                        <div className="mb-2">
                            <strong>{uploadStatus}</strong>
                            {uploadProgress > 0 && uploadProgress < 100 && (
                                <span className="ms-2">({Math.round(uploadProgress)}%)</span>
                            )}
                        </div>
                        <ProgressBar
                            now={uploadProgress}
                            label={`${Math.round(uploadProgress)}%`}
                            animated={isUploading}
                            striped={isUploading}
                            variant={
                                uploadStatus === 'Upload failed' ? 'danger' :
                                uploadStatus === 'Upload completed!' ? 'success' :
                                'primary'
                            }
                        />
                    </Alert>
                )}

                <p>Only required files will be uploaded.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={handleCloseStudentFilesModal}
                    disabled={isUploading}
                >
                    {isUploading ? 'Uploading...' : 'Close'}
                </Button>
            </Modal.Footer>
        </Modal>
    </>);
}

export default StudentFiles;